import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import DocumentCircleIcon from '../../../../assets/document-circle-icon.svg';

const NewsletterCommentMentionNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={DocumentCircleIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> mentioned you in a</span>{' '}
          <span className="font-extrabold text-growth-green">comment</span>
        </p>
        {meta.commentText && (
          <div className="mt-2 mb-1">
            <p className="font-semibold text-sm text-growth-green-900 break-words">
              "{meta.commentText}"
            </p>
          </div>
        )}
        {meta.articleTitle && (
          <p className="text-sm text-gray-600 mb-2">on "{meta.articleTitle}"</p>
        )}
      </div>
    </div>
  );
};

export default NewsletterCommentMentionNotification;
